import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

import { useOrganizations } from '@cast/shared-organization-context-data-access';

const APA_INTEGRATIONS_QUERY_KEY = 'apa-integrations';

export const getIntegrationsQueryKey = () =>
  [APA_INTEGRATIONS_QUERY_KEY] as const;

const getListIntegrationsQueryOptions = ({
  organizationId,
}: {
  organizationId?: string;
}) =>
  queryOptions({
    queryKey: getIntegrationsQueryKey(),
    queryFn: async () => {
      const { data } = await apiClient.apa.listIntegrations({
        organizationId: organizationId!,
      });
      return data.integrations || [];
    },
    enabled: !!organizationId,
  });

export const useListIntegrationsQuery = () => {
  const { currentOrganization } = useOrganizations();

  const { data, isLoading, error, refetch } = useQuery(
    getListIntegrationsQueryOptions({ organizationId: currentOrganization?.id })
  );

  return { integrations: data, isLoading, error, refetch };
};
